import { render, staticRenderFns } from "./HomeCard.vue.html?vue&type=template&id=efc33d20&"
import script from "./HomeCard.component.js?vue&type=script&lang=vueJs&"
export * from "./HomeCard.component.js?vue&type=script&lang=vueJs&"
import style0 from "./HomeCard.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports